/**
 * 리다이렉트 대상 검증 — 오픈 리다이렉트 방어.
 * 앱 내부 경로만 허용한다: 프로토콜 상대(//)·절대 URL·백슬래시 거부.
 */
export function safePath(p: unknown, fallback = '/'): string {
    if (typeof p !== 'string' || !p.startsWith('/')) return fallback;
    if (p.startsWith('//') || p.includes('\\') || p.includes('://')) return fallback;
    return p;
}
